var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import { jsx as _jsx } from "react/jsx-runtime";
import React, { forwardRef } from 'react';
import classNames from 'classnames';
import useTaroBaseEvents from '../_util/hooks/useTaroBaseEvents';
const Icon = (_a, ref) => {
    var { style, className, type, size = 30, color } = _a, rest = __rest(_a, ["style", "className", "type", "size", "color"]);
    const props = useTaroBaseEvents(rest);
    const mergedStyle = Object.assign({}, style, {
        fontSize: size ? `${size}px` : undefined,
        color
    });
    return (_jsx("i", Object.assign({ ref: ref, style: mergedStyle, className: classNames({
            ['weui-icon-' + type]: type !== 'loading',
            'weui-loading': type === 'loading'
        }, className) }, props)));
};
export default forwardRef(Icon);
